import React, { useState } from 'react';
import { Button, Modal } from 'react-bootstrap';
import { Link } from "react-router-dom";
import Select from "react-select";
    
const EditItemProperty = ({ show, onClose, id, onUpdated }) => {
    const [colorChange] = useState(null);

    const propertyType = [
        { value: 0, label: 'Color' },
        { value: 1, label: 'Taste' }
    ]

    const [selectedOption, setSelectedOption] = useState(null);

    return (
        <Modal show={show} size="md">
            <div className="modal-content">
                <div className="modal-header" style={{ backgroundColor: '#3ab384' }}>
                    <h3 className="modal-title text-white">Update Property</h3>
                    <Button variant="" type="button" className="close px-6 py-2" data-dismiss="modal" onClick={onClose}>
                        <span className="text-white">×</span>
                    </Button>
                </div>
                <div className="modal-body">
                    <div className="row">
                        <div className="col-lg-12 mb-2">
                            <label className="text-black font-w500 fs-7">Property Type<span className="required">*</span></label>
                            <Select placeholder="Select Property Type"
                                defaultValue={propertyType[0]}
                                onChange={setSelectedOption}
                                options={propertyType}
                            />
                        </div>
                        <div className="col-lg-12 mb-2">
                            <label className="text-black font-w500 fs-7">Property<span className="required">*</span></label>
                            <input type="text" className="form-control" placeholder="Enter Property" defaultValue={'Red'} />
                        </div>
                        <div className="col-lg-12 mb-2">
                            <label className="text-black font-w500 fs-7">Description</label>
                            <textarea rows={5} className="form-control h-auto" name="comment" placeholder="Description" defaultValue={"The food color appears rich and vibrant, highlighted by the deep red hue of the sambar, reflecting a bold and spicy flavor profile."} />
                        </div>
                    </div>
                    <div className="d-flex align-items-center justify-content-end gap-3 mt-4 mb-4">
                        <Link type="submit" className="btn btn-sm btn-primary" onClick={onClose}>Update Property <i className="fas fa-angle-double-right ms-2"></i></Link>
                    </div>
                </div>
            </div>
        </Modal>
    );
};

export default EditItemProperty;
